import type { LinkProps } from '@hover/blueprint';
import { Link } from '@hover/blueprint';
import React from 'react';

interface NavLinkProps extends LinkProps {
  active?: boolean;
}

export const NavLink = ({ active, ...props }: NavLinkProps) => (
  <Link
    color={active ? 'neutral.800' : 'neutral.900'}
    fontSize="200"
    fontWeight="700"
    justifyContent="center"
    marginRight="600"
    sx={{
      '-webkit-font-smoothing': 'antialiased',
    }}
    textDecoration="none"
    whiteSpace="nowrap"
    {...props}
  />
);
